export const compareHeadToHead = (team1, team2, allGames) => {
    let team1HeadToHeadPoints = 0;
    let team2HeadToHeadPoints = 0;
    let team1HeadToHeadGoalDifferential = 0;
    let team2HeadToHeadGoalDifferential = 0;
    let team1GoalsScored = 0;
    let team2GoalsScored = 0;
    let team1GoalsAllowed = 0;
    let team2GoalsAllowed = 0;

    for (const gameObj of allGames) {
        const game = gameObj.game;
        const finalScore = game.finalScore;
        const homeTeamName = game.homeTeam.name;
        const visitorTeamName = game.visitorTeam.name;

        if ((homeTeamName === team1.name && visitorTeamName === team2.name) || (homeTeamName === team2.name && visitorTeamName === team1.name)) {
            const homeGoals = finalScore.homeGoals;
            const visitorGoals = finalScore.visitorGoals;

            if (homeTeamName === team1.name) {
                team1GoalsScored += homeGoals;
                team1GoalsAllowed += visitorGoals;
                if (homeGoals > visitorGoals) {
                    team1HeadToHeadPoints += 2;
                } else if (visitorGoals > homeGoals) {
                    team2HeadToHeadPoints += 2;
                } else {
                    team1HeadToHeadPoints += 1;
                    team2HeadToHeadPoints += 1;
                }
            } else { // homeTeamName is team2.name
                team2GoalsScored += homeGoals;
                team2GoalsAllowed += visitorGoals;
                if (homeGoals > visitorGoals) {
                    team2HeadToHeadPoints += 2;
                } else if (visitorGoals > homeGoals) {
                    team1HeadToHeadPoints += 2;
                } else {
                    team1HeadToHeadPoints += 1;
                    team2HeadToHeadPoints += 1;
                }
            }
        }
    }
    
    team1HeadToHeadGoalDifferential = team1GoalsScored - team1GoalsAllowed;
    team2HeadToHeadGoalDifferential = team2GoalsScored - team2GoalsAllowed;

    if (team1HeadToHeadPoints !== team2HeadToHeadPoints) return team2HeadToHeadPoints - team1HeadToHeadPoints;
    if (team1HeadToHeadGoalDifferential !== team2HeadToHeadGoalDifferential) return team2HeadToHeadGoalDifferential - team1HeadToHeadGoalDifferential;
    if (team1GoalsScored !== team2GoalsScored) return team2GoalsScored - team1GoalsScored;
    if (team1GoalsAllowed !== team2GoalsAllowed) return team1GoalsAllowed - team2GoalsAllowed;
    return 0;
};